module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0019.jpg?v=d200d60c";